import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { ShippingAddressInputFieldProps } from '../../types/shippingAddressInputFieldProps'

type ShippingAddressStreet1Props = ShippingAddressInputFieldProps

export const ShippingAddressStreet1 = ({ isDisabled }: ShippingAddressStreet1Props): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      name="shippingAddress.streetAddress1"
      label={t('customer_modal.form.shipping_address.street_address_1.label')}
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
